import { RemoteIdentityCardsService } from '@prodcard/core-web-app'
import { httpClient } from './remote'

const identityCardsService = new RemoteIdentityCardsService(httpClient)

export { identityCardsService }
